export const indexLink = () => {}
